import { useNavigate, useSearchParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { TokenPurpose } from "@/enum";

import { ROUTE_CONFIG } from "@/routes/config";

import FormContainer from "../../components/FormContainer";
import { useConfirmEmailMutation } from "../../redux/auth.api";

const { LOGIN } = ROUTE_CONFIG;

export default function ConfirmEmail() {
	const { t } = useTranslation();
	const ts = (key: string, options = {}) => t(`confirm-email.${key}`, options);
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const [confirmEmail, { isLoading, error, isSuccess }] = useConfirmEmailMutation();
	const onSubmit = async () => {
		if (!isSuccess) {
			try {
				await confirmEmail({
					token: searchParams.get("token") || "",
					purpose: TokenPurpose.REGISTRATION,
				}).unwrap();
			} catch (err) {
				console.error(err);
			}
		} else {
			navigate(LOGIN);
		}
	};

	return (
		<div className="w-full h-full flex items-center justify-center">
			<FormContainer
				formContainerClassName="min-h-fit my-6"
				description={isSuccess ? ts("company-successfully-confirmed") : ts("description")}
				formError={error}
				handleSubmit={onSubmit}
				isLoading={isLoading}
				submitButtonText={isSuccess ? ts("go-to-login") : ts("confirm")}
				title={ts("title")}
			>
				<></>
			</FormContainer>
		</div>
	);
}
